// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1UTc5","header":"Messages_header__3rDVU"};